import { OnInit, TemplateRef, ElementRef, OnDestroy } from '@angular/core';
import { LoginService } from '../services/login.service';
import { Globals } from '../objects/Globals';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginModalComponent } from '../login-modal/login-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TokenManager } from '../Globals';
import { ForgotLoginComponent } from '../forgot-login/forgot-login.component';
import { EnvService } from '../env.service';
import { ModalControlComponent } from '../modal-control/modal-control.component';
import { WorkspaceService } from '../services/workspace.service';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(route, loginService, globals, router, modalService, tokenManager, env, workspaceService) {
        var _this = this;
        this.route = route;
        this.loginService = loginService;
        this.globals = globals;
        this.router = router;
        this.modalService = modalService;
        this.tokenManager = tokenManager;
        this.env = env;
        this.workspaceService = workspaceService;
        this.submitted = false;
        this.isEmptyUsername = false;
        this.isInvalid = false;
        this.isLoginPage = false;
        this.showLoginTerms = false;
        this.portalTitle = this.env.portalTitle;
        this.portalBackground = this.env.loginBackdrop;
        this.primaryColour = this.env.primaryColor;
        this.showLoginTerms = this.env.showLoginTerms;
        this.urlRouter = router.events.subscribe(function (val) {
            if (router.url.indexOf("/login") > -1) {
                _this.isLoginPage = true;
            }
            else {
                _this.isLoginPage = false;
            }
        });
    }
    LoginComponent.prototype.openModal = function (template, username, event) {
        this.isInvalid = false;
        this.isEmptyUsername = false;
        if (event.key == "Enter") {
            this.launchModal(template, username);
        }
    };
    LoginComponent.prototype.launchModal = function (template, username) {
        var _this = this;
        document.querySelectorAll('.body-content').item(0).classList.add('mb-login');
        document.querySelectorAll('.navbar').item(0).classList.add('mb-login');
        if (username) {
            this.isEmptyUsername = false;
            var config = {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-dialog-centered modal-login',
                focus: false,
                initialState: {
                    username: username.trim()
                }
            };
            this.modalService.onHide.subscribe(function (reason) {
                _this.username.nativeElement.focus();
            });
            this.modalRef = this.modalService.show(LoginModalComponent, config);
            this.modalRef.content.invalid.subscribe(function (value) {
                _this.isInvalid = value;
            });
        }
        else {
            this.isEmptyUsername = true;
        }
    };
    LoginComponent.prototype.forgotLoginDetails = function () {
        var config = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-dialog-centered modal-forgot-login',
            focus: false
        };
        document.querySelectorAll('.body-content').item(0).classList.add('mb-login');
        document.querySelectorAll('.navbar').item(0).classList.add('mb-login');
        this.modalRef = this.modalService.show(ForgotLoginComponent, config);
    };
    LoginComponent.prototype.onChangeUsername = function () {
        this.isInvalid = false;
        this.isEmptyUsername = false;
    };
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        var sessionCookie = JSON.parse(this.tokenManager.retrieve("BRNSessionKey"));
        var self = this;
        if (sessionCookie) {
            this.loginService.getSession(sessionCookie).subscribe(function (result) {
                if (result) {
                    var checkSessionObject = JSON.parse(result);
                    if (checkSessionObject.SessionObject) {
                        var sessionObject = checkSessionObject.SessionObject;
                        self.globals.Session = sessionObject;
                        self.globals.CardItems = [];
                        var currentRoute = JSON.parse(_this.tokenManager.retrieve("BRNCurrentRoute"));
                        if (currentRoute) {
                            _this.router.navigateByUrl(currentRoute);
                        }
                        else {
                            _this.router.navigate(['/', 'home']);
                        }
                        _this.loginService.setSession(self.globals.Session);
                    }
                }
            }, function (error) {
                _this.tokenManager.store("BRNSessionKey", null);
            });
        }
        else {
            this.notificationPopup();
            //this.router.navigate(['/', 'login']);
        }
    };
    LoginComponent.prototype.notificationPopup = function () {
        var _this = this;
        if (this.isLoginPage && !this.globals.Session) {
            this.workspaceService.getNotificationPrompt().subscribe(function (result) {
                if (result) {
                    var notificationPrompt = JSON.parse(result);
                    //var notificationPrompt = {
                    //  Title: "<i>Notification to the users</i>",
                    //  Message: "Sime Darby Berhad eProcurement Portal will undergo a system upgrade. This upgrade is scheduled to start on 18th July 2020 from 7pm and is expected to complete on 18th July 2020 at 9pm (KL Time). Please log out of the system by the designated time to avoid any lost work. We apologize for any inconvenience this may cause."}        
                    var config = {
                        keyboard: false,
                        ignoreBackdropClick: true,
                        class: 'modal-dialog-centered modal-notification',
                        focus: false,
                        initialState: {
                            type: "notification",
                            title: notificationPrompt.Title,
                            message: notificationPrompt.Message
                        }
                    };
                    document.querySelectorAll('.body-content').item(0).classList.add('mb-login');
                    document.querySelectorAll('.navbar').item(0).classList.add('mb-login');
                    _this.modalRef = _this.modalService.show(ModalControlComponent, config);
                }
            });
        }
    };
    LoginComponent.prototype.ngOnDestroy = function () {
        if (this.urlRouter) {
            this.urlRouter.unsubscribe();
        }
    };
    return LoginComponent;
}());
export { LoginComponent };
